import { useEffect, useState } from 'react'

export const usePasswordCriteriaControl = () => {
  const [allCriteriaMet, setAllCriteriaMet] = useState(false)
  const [showErrorState, setShowErrorState] = useState(false)

  const checkCriteriaOnBlur = () => setShowErrorState(!allCriteriaMet)

  useEffect(() => {
    if (allCriteriaMet) setShowErrorState(false)
  }, [allCriteriaMet])

  return {
    allCriteriaMet,
    setAllCriteriaMet,
    showErrorState,
    setShowErrorState,
    checkCriteriaOnBlur,
  }
}
